import HomeWebService from "../service/home_web_service";
import DataResult from "../data/bean/data_result";
import GeneralWebService from "../service/general_web_service";
import AuthBloc from "./auth_bloc";
import GeneralBloc from "./general_bloc";
import emojiStrip from "emoji-strip";
import { isEmptyObject } from "jquery";
import { numberValidation } from "../ui/component/app_validation";

export default class UtilBloc {

  //Check is value is not null && not undefined
  static isValid(value) {
    if (value !== undefined) return true;
    if (value !== null) return true;
    return false;
  }

  //Check if value contain number only
  static isContainNumberOnly(value) {
    return /^\d+$/.test(value);
  }

  //Check if value contain number only
  static validateDecimal(input) {
    console.log("input", input);
    const regex = /^[0-9]*\.?[0-9]*$/;
    console.log("validate result", regex.test(input))
    return regex.test(input);
  }

  //Check if value is null or empty
  static isNullOrEmpty(value) {
    return value === undefined || !value || value === null || value === '' || value === 'undefined';
  }

  //Check if NRIC validation
  static nricValidation = (value) => {
    if (value == "" || value == null) {
      return true;
    } else if (!this.isContainNumberOnly(value)) {
      return true;
    } else if (value.length < 12 || value.length > 12) {
      return true;
    } else {
      return false;
    }
  };

  static nameValidation = (name, isCompany = false) => {
    if (name === "" || name === null) {
      return true;
    } else if (name.length < 3) {
      return true;
    } else if (name.charAt(0) === " ") {
      return true;
    } else if (name.includes("  ")) {
      return true;
    } else if (/(\s-|-\s)/.test(name)) {
      return true;
    } else if (isCompany ? /[!#%*;?~{}]/.test(name) : /[0-9!#%*;?~{}]/.test(name)) {
      return true;
    } else if (name.charAt(name.length - 1) === " ") {
      return true;
    } else if (/(.)\1\1\1/.test(name)) {
      return true;
    } else {
      return false;
    }
  };


  static phoneNumberValidation = (value) => {
    // value = value.replaceAll("-", "");
    if (value == "") {
      return true;
    }
    else if (!this.isContainNumberOnly(value)) {
      return true;
    }
    // Temporary disabled
    // else if (value.charAt(3) != "1") {
    //   return Labels.ERROR_MOBILE_NUMBER;
    // }
    // else if (value.charAt(0) == "0") {
    //   return true;
    // } 
    else if (value.substring(0, 2) == "11" && value.length < 9) {
      return true;
    } else if (
      (value.substring(0, 2) == "10" ||
        value.substring(0, 2) == "12" ||
        value.substring(0, 2) == "13" ||
        value.substring(0, 2) == "14" ||
        value.substring(0, 2) == "15" ||
        value.substring(0, 2) == "16" ||
        value.substring(0, 2) == "17" ||
        value.substring(0, 2) == "18" ||
        value.substring(0, 2) == "19") &&
      value.length < 9
    ) {
      return true;
    } else {
      return false;
    }
  };

  static clearEmoji(value) {
    const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1FAB0}-\u{1FABF}\u{1FAC0}-\u{1FAFF}\u{1F004}\u{1F0CF}\u{1F18E}\u{1F191}\u{1F1E6}-\u{1F1FF}\u{1F201}\u{1F202}\u{1F232}-\u{1F251}\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1FAB0}-\u{1FABF}\u{1FAC0}-\u{1FAFF}\u{1F004}\u{1F0CF}\u{1F18E}\u{1F191}\u{1F1E6}-\u{1F1FF}\u{1F201}\u{1F202}\u{1F232}-\u{1F251}\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1FAB0}-\u{1FABF}\u{1FAC0}-\u{1FAFF}\u{1F004}\u{1F0CF}\u{1F18E}\u{1F191}\u{1F1E6}-\u{1F1FF}\u{1F201}\u{1F202}\u{1F232}-\u{1F251}\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1FAB0}-\u{1FABF}\u{1FAC0}-\u{1FAFF}\u{1F004}\u{1F0CF}\u{1F18E}\u{1F191}\u{1F1E6}-\u{1F1FF}\u{1F201}\u{1F202}\u{1F232}-\u{1F251}\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1FAB0}-\u{1FABF}\u{1FAC0}-\u{1FAFF}\u{1F004}\u{1F0CF}\u{1F18E}\u{1F191}\u{1F1E6}-\u{1F1FF}\u{1F201}\u{1F202}\u{1F232}-\u{1F251}\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1FAB0}-\u{1FABF}\u{1FAC0}-\u{1FAFF}\u{1F004}\u{1F0CF}\u{1F18E}\u{1F191}\u{1F1E6}-\u{1F1FF}\u{1F201}\u{1F202}\u{1F232}-\u{1F251}]/gu;
    const sanitizedValue = value.replace(emojiRegex, '');
    return emojiStrip(sanitizedValue);
  }

  static emailValidation = (value) => {
    const reg =
      /^[a-zA-Z0-9&(),./_\-]+@[a-zA-Z0-9]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/;

    if (this.isNullOrEmpty(value)) {
      return true;
    } else if (value.length > 60) {
      return true;
    } else if (value.charAt(0) === " ") {
      return true;
    } else if (!reg.test(value)) {
      return true;
    } else if (value.charAt(value.length - 1) === " ") {
      return true;
    } else {
      return false;
    }
  };

  //Covert string to capitalize
  static capitalize(string) {
    return string[0].toUpperCase() + string.substr(1).toLowerCase()
  }

  static capitalizeWords(str) {
    console.log('no string', str)
    if (str?.length > 0 || !this.isNullOrEmpty(str)) {
      return str
        // .toLowerCase()
        .split(' ')
        .map(function (word) {
          return word?.length > 0 ? word[0].toUpperCase() + word.substr(1) : '';
        })
        .join(' ');
    } else {
      return ''
    }

  }


  static convertToMB(size) {
    return (size / (1024 * 1024)).toFixed(2);
  }

  //Format number
  static formatNumber(num) {
    let value = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    if (value === "NaN") {
      return 0;
    }
    return value;
  }

  static getUniqueListBy(arr, key) {
    return [...new Map(arr.map(item => [item[key], item])).values()]
  }

  //Format number with commas
  static numberWithCommas(x) {
    if (x) {
      let number = Number(x).toFixed(2);
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      return '';
    }

  }

  static downloadBinary(response, filename) {
    let a = document.createElement('a');
    a.href = window.URL.createObjectURL(new Blob([response]))
    a.download = filename
    document.body.appendChild(a)
    a.click();
    document.body.removeChild(a)
  }

  static truncateString(str, num) {
    // If the length of str is less than or equal to num
    // just return str--don't truncate it.
    if (str.length <= num) {
      return str;
    }
    // Return str truncated with '...' concatenated to the end of str.
    return str.slice(0, num) + "...";
  }


  static addFirstItemInArray(arr, object) {
    return [object].concat(arr)
  }

  static async downloadFile(module, id) {
    let resp = await HomeWebService.downloadFile(module, id);
    if (resp.data) {
      return new DataResult(true, resp.message, resp);
    } else {
      return new DataResult(false, resp.message, null);
    }
  }

  static async exportFileByModule(
    entity,
    dateFilter,
    fromDate,
    toDate,
    regions,
    page,
    searchBy,
    keyword,
    branches,
    agents,
    idModuleListing
  ) {
    let token = "";
    const session = await AuthBloc.checkSession();

    if (session) {
      token = session.accessToken;
    }

    let getDateFilter = GeneralBloc.getFilteredByDate(
      dateFilter,
      fromDate,
      toDate
    );

    let response = await GeneralWebService.exportFileByModule(
      token,
      entity,
      page,
      getDateFilter.beginDate,
      getDateFilter.endDate,
      regions,
      searchBy,
      keyword,
      branches,
      agents,
      idModuleListing,
      dateFilter
    );

    return response;
  }

  static validatePassword(value, name) {
    let expregular = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[_!@#\$%\^&\*])(?=.{8,})";
    let error = null;
    if (!value) {
      error = `Please enter ${name} password.`;
    } else if (!value.match(expregular)) {
      error = "Password must contain between 8-16 characters, with upper case, lower case, special character and numeric characters.";
    }
    return error
  }

  static validateUserName(value, name) {
    let error = null;
    if (!value) {
      error = `Please enter user name`;
    }
    return error
  }

  static validateField(value, name) {
    let error = null;
    if (!value) {
      error = `Please enter ${name}`;
    }
    return error
  }

  //compareDateToCurrentDate (yyyy-mm-dd)
  static compareDateToCurrentDate(date) {
    var today = new Date().setHours(0, 0, 0, 0);
    var eventOn = new Date(date).setHours(0, 0, 0, 0);
    let type = "";
    if (today < eventOn) {
      type = "incoming";
    } else if (today > eventOn) {
      type = "pass";
    } else {
      type = "today";
    }
    return type;
  }

  static replaceBulk(str, findArray, replaceArray) {
    var i, regex = [], map = {};
    for (i = 0; i < findArray.length; i++) {
      regex.push(findArray[i].replace(/([-[\]{}()*+?.\\^$|#,])/g, '\\$1'));
      map[findArray[i]] = replaceArray[i];
    }
    regex = regex.join('|');
    str = str.replace(new RegExp(regex, 'g'), function (matched) {
      return map[matched];
    });
    return str;
  }
  //field need to search , and value 
  static findItemInArray(list, field, value) {
    let item = [];
    item = list.filter(
      function (ev) {
        return ev[field] == value;
      }
    );
    return item
  }

  static extendedHealthDetailsDataValidation(object) {
    let validated = true;
    let {
      extendHealthDeclarationData, heartDiseaseData, highBloodPressureData,
      mentalIllnessData, cancerData, hivData, diabetesData, pulmonaryData, liverDiseaseData,
      kidneyDiseaseData, lossSensesData, physicalDisabilityData, consultationData, fatigueData,
      weightLossData, abnormalData, bloodUrineData, persistentData, geneticDisorderData, pregnancyDetails
    } = object;
    Object.keys(extendHealthDeclarationData).map(function (key) {
      if (key == 'isConsultOrTreatment' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(consultationData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(consultationData[key2]) || false);
        })
      }
      else if (key == 'hasGeneticDisorder' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(geneticDisorderData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(geneticDisorderData[key2]) || false);
        })
      }
      else if (key == 'hasHeartDisease' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(heartDiseaseData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(heartDiseaseData[key2]) || false);
        })
      }
      else if (key == 'hasHighBloodPressure' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(highBloodPressureData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(highBloodPressureData[key2]) || false);
        })
      }
      else if (key == 'hasMentalIllness' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(mentalIllnessData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(mentalIllnessData[key2]) || false);
        })
      }
      else if (key == 'hasCancer' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(cancerData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(cancerData[key2]) || false);
        })
      }
      else if (key == 'hasHIV' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(hivData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(hivData[key2]) || false);
        })
      }
      else if (key == 'hasDiabetes' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(diabetesData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(diabetesData[key2]) || false);
        })
      }
      else if (key == 'hasObstructivePulmonaryDisease' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(pulmonaryData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(pulmonaryData[key2]) || false);
        })
      }
      else if (key == 'hasLiverDisease' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(liverDiseaseData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(liverDiseaseData[key2]) || false);
        })
      }
      else if (key == 'hasKidneyDisease' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(kidneyDiseaseData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(kidneyDiseaseData[key2]) || false);
        })
      }
      else if (key == 'lossSenses' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(lossSensesData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(lossSensesData[key2]) || false);
        })
      }
      else if (key == 'physicalDisability' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(physicalDisabilityData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(physicalDisabilityData[key2]) || false);
        })
      }
      else if (key == 'prolongedFatigue' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(fatigueData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(fatigueData[key2]) || false);
        })
      }
      else if (key == 'unexplainedWeightLoss' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(weightLossData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(weightLossData[key2]) || false);
        })
      }
      else if (key == 'abnormalLump' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(abnormalData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(abnormalData[key2]) || false);
        })
      }
      else if (key == 'bloodUrine' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(bloodUrineData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(bloodUrineData[key2]) || false);
        })
      }
      else if (key == 'newPain' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(persistentData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(persistentData[key2]) || false);
        })
      }
      else if (key == 'isPregnant' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(pregnancyDetails).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(pregnancyDetails[key2]) || false);
        })
      } else {
        validated = validated && (!UtilBloc.isNullOrEmpty(extendHealthDeclarationData[key]) || false);
      }
    });
    return validated;
  }

  static extendedHealthDetailsDataValidation2(object) {
    let validated = true;
    let extendHealthDeclarationData = object;
    let dataDetails = extendHealthDeclarationData.details;
    let {
      heartDiseaseData, highBloodPressureData,
      mentalIllnessData, cancerData, hivData, diabetesData, pulmonaryData, liverDiseaseData,
      kidneyDiseaseData, lossSensesData, physicalDisabilityData, consultationData, fatigueData,
      weightLossData, abnormalData, bloodUrineData, persistentData, geneticDisorderData
    } = '';
    dataDetails?.length > 0 && dataDetails.map((item, idx) => {
      if (item.questionNo == 'q4a') {
        heartDiseaseData = item
      }
      if (item.questionNo == 'q4b') {
        highBloodPressureData = item
      }
      if (item.questionNo == 'q4c') {
        mentalIllnessData = item
      }
      if (item.questionNo == 'q4d') {
        cancerData = item
      }
      if (item.questionNo == 'q4e') {
        hivData = item
      }
      if (item.questionNo == 'q4f') {
        diabetesData = item
      }
      if (item.questionNo == 'q4g') {
        pulmonaryData = item
      }
      if (item.questionNo == 'q4h') {
        liverDiseaseData = item
      }
      if (item.questionNo == 'q4i') {
        kidneyDiseaseData = item
      }
      if (item.questionNo == 'q4j') {
        lossSensesData = item
      }
      if (item.questionNo == 'q4k') {
        physicalDisabilityData = item
      }
      if (item.questionNo == 'q5') {
        consultationData = item
      }
      if (item.questionNo == 'q6a') {
        fatigueData = item
      }
      if (item.questionNo == 'q6b') {
        weightLossData = item
      }
      if (item.questionNo == 'q6c') {
        abnormalData = item
      }
      if (item.questionNo == 'q6d') {
        bloodUrineData = item
      }
      if (item.questionNo == 'q6e') {
        persistentData = item
      }
      if (item.questionNo == 'q7') {
        geneticDisorderData = item
      }
    })

    Object.keys(extendHealthDeclarationData).map(function (key) {
      if (key == 'isConsultOrTreatment' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(consultationData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(consultationData[key2]) || false);
        })
      }
      else if (key == 'hasGeneticDisorder' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(geneticDisorderData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(geneticDisorderData[key2]) || false);
        })
      }
      else if (key == 'hasHeartDisease' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(heartDiseaseData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(heartDiseaseData[key2]) || false);
        })
      }
      else if (key == 'hasHighBloodPressure' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(highBloodPressureData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(highBloodPressureData[key2]) || false);
        })
      }
      else if (key == 'hasMentalIllness' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(mentalIllnessData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(mentalIllnessData[key2]) || false);
        })
      }
      else if (key == 'hasCancer' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(cancerData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(cancerData[key2]) || false);
        })
      }
      else if (key == 'hasHIV' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(hivData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(hivData[key2]) || false);
        })
      }
      else if (key == 'hasDiabetes' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(diabetesData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(diabetesData[key2]) || false);
        })
      }
      else if (key == 'hasObstructivePulmonaryDisease' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(pulmonaryData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(pulmonaryData[key2]) || false);
        })
      }
      else if (key == 'hasLiverDisease' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(liverDiseaseData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(liverDiseaseData[key2]) || false);
        })
      }
      else if (key == 'hasKidneyDisease' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(kidneyDiseaseData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(kidneyDiseaseData[key2]) || false);
        })
      }
      else if (key == 'lossSenses' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(lossSensesData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(lossSensesData[key2]) || false);
        })
      }
      else if (key == 'physicalDisability' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(physicalDisabilityData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(physicalDisabilityData[key2]) || false);
        })
      }
      else if (key == 'prolongedFatigue' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(fatigueData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(fatigueData[key2]) || false);
        })
      }
      else if (key == 'unexplainedWeightLoss' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(weightLossData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(weightLossData[key2]) || false);
        })
      }
      else if (key == 'abnormalLump' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(abnormalData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(abnormalData[key2]) || false);
        })
      }
      else if (key == 'bloodUrine' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(bloodUrineData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(bloodUrineData[key2]) || false);
        })
      }
      else if (key == 'newPain' && extendHealthDeclarationData[key] == 'Yes') {
        Object.keys(persistentData).map(function (key2) {
          validated = validated && (!UtilBloc.isNullOrEmpty(persistentData[key2]) || false);
        })
      }
      else if (key == 'pregnancyMonth') {
        if (extendHealthDeclarationData['isPregnant'] == 'Yes') {
          validated = validated && (!UtilBloc.isNullOrEmpty(extendHealthDeclarationData[key]) || false);
        }
      } else {
        validated = validated && (!UtilBloc.isNullOrEmpty(extendHealthDeclarationData[key]) || false);
      }
    });
    return validated;
  }

  static personalDetailsDataValidation(object) {
    let validated = true;
    let formData = object;
    Object.keys(formData).map(function (key) {
      if (key == 'email') {
        validated = validated && (!UtilBloc.emailValidation(formData[key]) || false);
      } else if (key === 'annualIncome') {
        if (formData[key] !== '> RM200,000') {
          validated = validated && (!UtilBloc.isNullOrEmpty(formData[key]) || false);
        } else {
          validated = validated && ((!UtilBloc.isNullOrEmpty(formData[key]) && !UtilBloc.isNullOrEmpty(formData['exactAnnualIncome'])) || false);
        }
      } else if (key === 'exactAnnualIncome') {
        if (formData['annualIncome'] === '> RM200,000') {
          validated = validated && ((!UtilBloc.isNullOrEmpty(formData[key]) && !UtilBloc.isNullOrEmpty(formData['annualIncome'])) || false);
        }
      } else if (key == 'state' || key == 'city') {
        if (formData['country'] != 'MYS' && !UtilBloc.isNullOrEmpty(formData['country'])) {
          // validated = true;
        } else {
          validated = validated && (!UtilBloc.isNullOrEmpty(formData[key]) || false);
        }
      } else if (key == 'mobileNo' || (key == 'officePhoneNo' && formData[key]) || (key == 'homePhoneNo' && formData[key])) {
        validated = validated && (UtilBloc.isContainNumberOnly(formData[key]) || false);
      } else if (key == 'corrState' || key == 'corrCity' || key == 'corrPostcode') {
        if (formData['corrCountry'] != 'MYS' && !UtilBloc.isNullOrEmpty(formData['country'])) {
          // validated = true;
        } else {
          validated = validated && (!UtilBloc.isNullOrEmpty(formData[key]) || false);
        }
      } else if (key == 'residentialAddress') {
        if (formData['isResidentialAddressCorrespondenceAddress'] == 'No') {
          validated = validated && (!UtilBloc.isNullOrEmpty(formData[key]) || false);
        }
      } else if (key == 'residentialState' || key == 'residentialCity' || key == 'residentialPostcode') {
        if (formData['isResidentialAddressCorrespondenceAddress'] == 'No') {
          if (formData['residentialCountry'] != 'MYS' && !UtilBloc.isNullOrEmpty(formData['residentialCountry'])) {
          } else {
            validated = validated && (!UtilBloc.isNullOrEmpty(formData[key]) || false);
          }
        }
      } else if (key == 'companyState' || key == 'companyPostcode' || key == 'companyCity') {
        if (formData['companyCountry'] != 'MYS' && !UtilBloc.isNullOrEmpty(formData['companyCountry'])) {
        } else {
          validated = validated && (!UtilBloc.isNullOrEmpty(formData[key]) || false);
        }
      } else if (
        key == 'representativeName' || key == 'branchCode' || key == 'proposalDate' || key == 'staffCode'
        || key == 'name' || key == 'gender' || key == 'idType' || key == 'idNo' || key == 'addIDType' || key == 'addIDNo'
        || key == 'dob' || key == 'occupation' || key == 'natureBusiness' || key == 'staffIcNo' || key == 'staffPhone'
        || key == 'staffEmail' || key == 'staffIcNo' || key == 'staffIcNo' || key === 'isPermamentAddressCorrespondenceAddress'
        || key === 'placeOfBirth2' || key === 'placeOfBirth3' || key === 'correspondenceAddress2' || key === 'correspondenceAddress3'
        || key === 'residentialAddress2' || key === 'residentialAddress3' || key === 'permanentAddress' || key == 'officePhoneNo'
        || key == 'homePhoneNo' || key === 'companyAddress2' || key === 'companyAddress3'
      ) {
        validated = validated;
      }
      else {
        validated = validated && (!UtilBloc.isNullOrEmpty(formData[key]) || false);
      }
      console.log("key", key, "validated", validated)
    })
    return validated;
  }

  static payorInformationDataValidation(object) {
    let validated = true;
    let formData = object;
    Object.keys(formData).map(function (key) {
      if (key == 'email') {
        validated = validated && (!UtilBloc.emailValidation(formData[key]) || false);
      } else if (key === 'annualIncome') {
        if (formData[key] !== '> RM200,000') {
          validated = validated && (!UtilBloc.isNullOrEmpty(formData[key]) || false);
        } else {
          validated = validated && ((!UtilBloc.isNullOrEmpty(formData[key]) && !UtilBloc.isNullOrEmpty(formData['exactAnnualIncome'])) || false);
        }
      } else if (key === 'exactAnnualIncome') {
        if (formData['annualIncome'] === '> RM200,000') {
          validated = validated && ((!UtilBloc.isNullOrEmpty(formData[key]) && !UtilBloc.isNullOrEmpty(formData['annualIncome'])) || false);
        }
      } else if (key == 'state' || key == 'city') {
        if (formData['country'] != 'MYS' && !UtilBloc.isNullOrEmpty(formData['country'])) {
          // validated = true;
        } else {
          validated = validated && (!UtilBloc.isNullOrEmpty(formData[key]) || false);
        }
      } else if (key == 'mobileNo' || (key == 'officePhoneNo' && formData[key]) || (key == 'homePhoneNo' && formData[key])) {
        validated = validated && (UtilBloc.isContainNumberOnly(formData[key]) || false);
      } else if (key == 'corrState' || key == 'corrCity' || key == 'corrPostcode') {
        if (formData['corrCountry'] != 'MYS' && !UtilBloc.isNullOrEmpty(formData['corrCountry'])) {
          // validated = true;
        } else {
          validated = validated && (!UtilBloc.isNullOrEmpty(formData[key]) || false);
        }
      } else if (key == 'residentialAddress') {
        if (formData['isResidentialAddressCorrespondenceAddress'] == 'No') {
          validated = validated && (!UtilBloc.isNullOrEmpty(formData[key]) || false);
        }
      } else if (key == 'residentialState' || key == 'residentialCity' || key == 'residentialPostcode') {
        if (formData['isResidentialAddressCorrespondenceAddress'] == 'No') {
          if (formData['residentialCountry'] != 'MYS' && !UtilBloc.isNullOrEmpty(formData['residentialCountry'])) {
          } else {
            validated = validated && (!UtilBloc.isNullOrEmpty(formData[key]) || false);
          }
        }
      } else if (key == 'companyState' || key == 'companyPostcode' || key == 'companyCity') {
        if (formData['companyCountry'] != 'MYS' && !UtilBloc.isNullOrEmpty(formData['companyCountry'])) {
        } else {
          validated = validated && (!UtilBloc.isNullOrEmpty(formData[key]) || false);
        }
      } else if (key === 'addIDType') {
        if (formData[key] === 'oldIcNo') {
          validated = validated && (!UtilBloc.isNullOrEmpty(formData['oldIcNo']) || false);
        } else if (formData[key] === 'birthCertNo') {
          validated = validated && (!UtilBloc.isNullOrEmpty(formData['birthCertNo']) || false);
        } else {
          validated = validated;
        }
      } else if (key === 'oldIcNo') {
        if ((formData['addIDType'] === 'oldIcNo')) {
          validated = validated && (!UtilBloc.isNullOrEmpty(formData[key]) || false);
        }
      } else if (key === 'birthCertNo') {
        if ((formData['addIDType'] === 'birthCertNo')) {
          validated = validated && (!UtilBloc.isNullOrEmpty(formData[key]) || false);
        }
      } else if (
        key == 'addIDNo' || key === 'placeOfBirth2' || key === 'placeOfBirth3' || key == 'residentialAddress2' || key == 'residentialAddress3'
        || key == 'correspondenceAddress2' || key == 'correspondenceAddress3' || key == 'officePhoneNo' || key == 'homePhoneNo' || key === 'companyAddress2' || key === 'companyAddress3'
      ) {
        validated = validated
      }
      else {
        validated = validated && (!UtilBloc.isNullOrEmpty(formData[key]) || false);
      }
      console.log("key", key, "validated", validated)
      console.log("value", formData[key])
    })
    return validated;
  }

  static oilGasOccupationDataValidation(object) {
    let validated = true;
    let oilGasOccupationData = object;
    Object.keys(oilGasOccupationData).map(function (key) {
      if (key == 'hazardousDetails') {
        validated = oilGasOccupationData['isHazardousDuties'] == 'Yes' ? validated && (!UtilBloc.isNullOrEmpty(oilGasOccupationData[key]) || false) : validated;
      }
      else if (
        (
          key == 'isJobScopeHeavy' || key == 'isJobScopeChemical' || key == 'isJobScopeEquipment' || key == 'isJobScopeExplosives' ||
          key == 'isJobScopeVoltages' || key == 'isJobScopeUnderwater' || key == 'isJobScopeHeavyDetails' || key == 'isJobScopeChemicalDetails' ||
          key == 'isJobScopeEquipmentDetails' || key == 'isJobScopeExplosivesDetails' || key == 'isJobScopeVoltagesDetails'
        )
        && oilGasOccupationData['isJobScopeNo'] == 'Yes'
      ) {
        validated = validated;
      }
      else if (key == 'isJobScopeHeavyDetails') {
        validated = oilGasOccupationData['isJobScopeHeavy'] == 'Yes' && oilGasOccupationData['isJobScopeNo'] == 'No' ? validated && (!UtilBloc.isNullOrEmpty(oilGasOccupationData[key]) || false) : validated;
      }
      else if (key == 'isJobScopeChemicalDetails') {
        validated = oilGasOccupationData['isJobScopeChemical'] == 'Yes' && oilGasOccupationData['isJobScopeNo'] == 'No' ? validated && (!UtilBloc.isNullOrEmpty(oilGasOccupationData[key]) || false) : validated;
      }
      else if (key == 'isJobScopeEquipmentDetails') {
        validated = oilGasOccupationData['isJobScopeEquipment'] == 'Yes' && oilGasOccupationData['isJobScopeNo'] == 'No' ? validated && (!UtilBloc.isNullOrEmpty(oilGasOccupationData[key]) || false) : validated;
      }
      else if (key == 'isJobScopeExplosivesDetails') {
        validated = oilGasOccupationData['isJobScopeExplosives'] == 'Yes' && oilGasOccupationData['isJobScopeNo'] == 'No' ? validated && (!UtilBloc.isNullOrEmpty(oilGasOccupationData[key]) || false) : validated;
      }
      else if (key == 'isJobScopeVoltagesDetails') {
        validated = oilGasOccupationData['isJobScopeVoltages'] == 'Yes' && oilGasOccupationData['isJobScopeNo'] == 'No' ? validated && (!UtilBloc.isNullOrEmpty(oilGasOccupationData[key]) || false) : validated;
      }
      // else if (key == 'isJobScopeUnderwaterDetails') {
      //   validated = oilGasOccupationData['isJobScopeUnderwater'] == 'Yes' && oilGasOccupationData['isJobScopeNo'] == 'No' ? validated && (!UtilBloc.isNullOrEmpty(oilGasOccupationData[key]) || false) : validated;
      // }
      else if (key == 'isAccidentDetails') {
        validated = oilGasOccupationData['isAccident'] == 'Yes' ? validated && (!UtilBloc.isNullOrEmpty(oilGasOccupationData[key]) || false) : validated;
      }
      else if (key == 'helicopterToRigDuration' || key == 'helicopterToRigFreq') {
        validated = oilGasOccupationData['isHelicopter'] == 'Yes' ? validated && (UtilBloc.isContainNumberOnly(oilGasOccupationData[key]) || false) : validated;
      }
      else if (key == 'otherDetails') {
        validated = oilGasOccupationData['isOthers'] == 'Yes' ? validated && (!UtilBloc.isNullOrEmpty(oilGasOccupationData[key]) || false) : validated;
      }
      else if (key == 'workingDuration' || key == 'travelFreqToRig') {
        validated = (UtilBloc.isContainNumberOnly(oilGasOccupationData[key]) || false);
      }
      else {
        validated = validated && (!UtilBloc.isNullOrEmpty(oilGasOccupationData[key]) || false);
      }
      //if no checkbox is checked
      if (
        (
          oilGasOccupationData['isJobScopeHeavy'] == 'No' && oilGasOccupationData['isJobScopeChemical'] == 'No' && oilGasOccupationData['isJobScopeEquipment'] == 'No' &&
          oilGasOccupationData['isJobScopeExplosives'] == 'No' && oilGasOccupationData['isJobScopeVoltages'] == 'No' && oilGasOccupationData['isJobScopeUnderwater'] == 'No' &&
          oilGasOccupationData['isJobScopeNo'] == 'No'
        ) || (oilGasOccupationData['isHelicopter'] == 'No' && oilGasOccupationData['isOthers'] == 'No')
      ) {
        validated = false;
      }
    });
    return validated;
  }

  static foreignerDetailsDataValidation(object, maritalStatus) {
    let validated = true;
    let foreignData = object;

    const {
      isBank, isProperty, isBusiness, isInvestment, isRelatives, isDunHave
    } = object;

    Object.keys(foreignData).map(function (key) {
      if (
        (key == 'isSpouseMalaysian' || key == 'spouseOccupation' || key == 'spouseNationality' || key == 'familyMember')
        && maritalStatus != 'Married' && maritalStatus != undefined
      ) {
        validated = validated;
      } else if (key == 'arriveDate') {
        validated = validated && (!isEmptyObject(foreignData[key]) || false);
      } else if (key == 'stayDuration') {
        validated = validated && (!numberValidation(foreignData[key]) || false);
      } else if (key == 'isBankDetails') {
        validated = isBank == 'Yes' && isDunHave == "No" ? validated && (!UtilBloc.isNullOrEmpty(foreignData[key]) || false) : validated;
      } else if (key == 'isPropertyDetails') {
        validated = isProperty == 'Yes' && isDunHave == "No" ? validated && (!UtilBloc.isNullOrEmpty(foreignData[key]) || false) : validated;
      } else if (key == 'isInvestmentDetails') {
        validated = isInvestment == 'Yes' && isDunHave == "No" ? validated && (!UtilBloc.isNullOrEmpty(foreignData[key]) || false) : validated;
      } else if (key == 'isBusinessDetails') {
        validated = isBusiness == 'Yes' && isDunHave == "No" ? validated && (!UtilBloc.isNullOrEmpty(foreignData[key]) || false) : validated;
      } else if (key == 'isRelativesDetails') {
        validated = isRelatives == 'Yes' && isDunHave == "No" ? validated && (!UtilBloc.isNullOrEmpty(foreignData[key]) || false) : validated;
      } else if (key == 'otherStatusInMalaysia') {
        validated = foreignData['statusInMalaysia'] == 'Others' ? validated && (!UtilBloc.isNullOrEmpty(foreignData[key]) || false) : validated;
      } else if (key == 'travelFreq') {
        validated = foreignData['isTravel'] == 'Yes' ? validated && (!UtilBloc.isNullOrEmpty(foreignData[key]) || false) : validated;
      }
      else if (
        (key == 'isBankDetails' || key == 'isPropertyDetails' || key == 'isInvestmentDetails' || key == 'isBusinessDetails' || key == 'isRelativesDetails')
        && isDunHave == "Yes"
      ) {
        validated = validated;
      }
      else {
        validated = validated && (!UtilBloc.isNullOrEmpty(foreignData[key]) || false);
      }

      //if no checkbox is checked
      if (isBank == "No" && isProperty == "No" && isInvestment == "No" && isBusiness == "No" && isRelatives == "No" && isDunHave == "No") {
        validated = false;
      }

    });
    return validated;
  }

  static residentialDetailsDataValidation(object) {
    let validated = true;
    let residentialData = object;
    const { isFirstEMploymentReason, typeOfStay, notStayThroughoutCountry, isStayThroughout } = residentialData;

    Object.keys(residentialData).forEach(function (key) {
      if (residentialData.residenceOrTravelCountry !== "MYS" && (key === "residenceOrTravelState" || key === "residenceOrTravelPostcode" || key === "residenceOrTravelCity")) {
        return;
      }
      if (notStayThroughoutCountry !== "MYS" && (key === "notStayThroughoutState" || key === "notStayThroughoutCity" || key === "notStayThroughoutPostcode")) {
        return;
      }
      if (isFirstEMploymentReason === "Yes" && (key === "notFisrtEmployment")) {
        return;
      }
      if (typeOfStay !== "Other accommodation?" && (key === "otherAccommodationType")) {
        return;
      }
      console.log(key, notStayThroughoutCountry)
      if (isStayThroughout === "Yes" && (key === "notStayThroughoutAddress" || key === "notStayThroughoutCountry" || key === "notStayThroughoutState" || key === "notStayThroughoutPostcode" || key === "notStayThroughoutCity")) {
        console.log("here")
        return;
      }
      validated = validated && (!UtilBloc.isNullOrEmpty(residentialData[key]) || false);
    });
    return validated;
  }
}
